// extracted by mini-css-extract-plugin
module.exports = {"componentStyles":"AddToCal_componentStyles__32ku2","link":"AddToCal_link__Yg1vx","button":"AddToCal_button__3Z1Ve","dropItems":"AddToCal_dropItems__3C_TS"};